























































































































































































import { defineComponent } from '@vue/composition-api';
import { TimeIcon } from 'tdesign-icons-vue';
import _ from 'lodash';

import DebounceTooltip from '@/renderer/components/common/DebounceTooltip.vue';

import MyLoadingIcon from '@/renderer/views/desktop/FileManagement/Transmission/components/MyLoadingIcon.vue';
import { SubTask, Task } from '@/renderer/scripts/utils/TaskManager/types';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { calcRemainingMessageBySeconds } from '@/renderer/scripts/utils/tools/packages/transmission';
import { getSpeedAndUnit } from '@/renderer/scripts/utils/tools/packages/unit';

export default defineComponent({
  components: {
    DebounceTooltip,
    TimeIcon,
    MyLoadingIcon,
  },
  props: {
    list: {
      required: true,
      type: Array as () => Task<FileInfo>[],
      default: [],
    },
    autoHeight: {
      type: Number,
      default: 640,
    },
  },
  setup(props, context) {
    const methods = {
      onEventProxy(command: string, task: Task<FileInfo>) {
        context.emit('onAction', {
          command,
          task,
        });
      },
      // 获取已经下载的子任务的大小
      getLoadedFromSubTasks(item: Task<FileInfo>) {
        let loadedSize = 0;
        item.getList().forEach((subtask: SubTask<FileInfo>) => {
          // 任务进度百分比(精度低)，loaded 子任务加载了多少
          const { loaded } = subtask;
          // 文件大小
          const { size } = subtask.info;
          loadedSize = _.add(loaded || 0, loadedSize);
        });
        return loadedSize;
      },
      // 计算整个任务下的剩余时间描述文本
      getRemainingMessage(item: Task<FileInfo>): string {
        let totalRemainTime = 0;
        item.getList().forEach((subTask: SubTask<FileInfo>) => {
          totalRemainTime = _.add(totalRemainTime, subTask.remainingTime);
        });
        return calcRemainingMessageBySeconds(totalRemainTime);
      },
      calcIoPercent(ioPercent: number | undefined): string {
        if (ioPercent === undefined) return '';
        let percent100 = _.multiply(ioPercent, 100);
        percent100 = _.round(percent100, 0);
        return `${percent100}%`;
      },
      /**
       * @description 获取百分比size 效果 10mb/100mb
       * TODO 需要优化3位数以上的百分比显示
       * @param item
       */
      getSizePercent(item: Task<FileInfo>) {
        const loadedSize = methods.getLoadedFromSubTasks(item);
        const { size = 0 } = item;
        const sizeAndUnit = getSpeedAndUnit(size);
        const loadedSpeed = getSpeedAndUnit(loadedSize);
        if (item.status === 'success') {
          return `${sizeAndUnit.speed}${sizeAndUnit.unit}`;
        }
        return `${loadedSpeed.speed}${loadedSpeed.unit}/${sizeAndUnit.speed}${sizeAndUnit.unit}`;
      },
      percentFunc(item: Task<FileInfo>) {
        if (item.getListLength() === 1) {
          return `${item.getItem(0).percent * 100}%`;
        }
        const tmp = item.progressText.split('/');
        return `${(Number(tmp[0]) / Number(tmp[1])) * 100}%`;
      },
    };
    return {
      ...methods,
    };
  },
});
